import React, { useState } from "react"
import CustomButton from "../../../UI/CustomButton/CustomButton"
import classes from "./StageSection.module.css"
import { AiOutlineMinus } from "react-icons/ai"
import { useFieldArray, Controller } from "react-hook-form"
import { useEffect } from "react"
import Input from "../../../UI/Form/Input"
import SlotField from "./SlotField"
import { MdArrowForwardIos } from "react-icons/md";
import { Collapse, IconButton } from "@mui/material"
import Field from "../../../UI/Field/Field"

const StageSection = (props) => {
    const { index, innerIndex, control, onRemove, residents } = props

    const [expanded, setExpanded] = useState(false)

    const handleExpandClick = () => {
        setExpanded(!expanded)
    }

    const { fields, remove, append } = useFieldArray({
        control,
        name: `lineup.${index}.stages.${innerIndex}.slots`
    })

    const addSlot = () => {
        append({ djs: [{ name: "", info_link: "" }], startAt: "", endAt: "", note: "solo" })
    }

    const removeSlot = (idx) => {
        if (fields.length > 1) {
            remove(idx)
        }
    }

    useEffect(() => {
        if (fields.length < 1) {
            addSlot()
        }
    }, [])

    return (
        <div className={classes.main}>
            <div className={classes.header}>
                <div className={classes.left}>
                    <h4>Stage {innerIndex + 1}</h4>
                    <IconButton className={expanded ? classes.expanded : ""} onClick={handleExpandClick}>
                        <MdArrowForwardIos/>
                    </IconButton>
                </div>
                <CustomButton
                    className={classes.removeBut}
                    onClick={() => onRemove(innerIndex)}
                >
                    <AiOutlineMinus />
                    <span>Remove</span>
                </CustomButton>
            </div>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <Field direction="column">
                    <Controller
                        name={`lineup.${index}.stages.${innerIndex}.name`}
                        control={control}
                        defaultValue=""
                        render={({
                            field: { onChange, value },
                            fieldState: { error }
                        }) => (
                            <Input
                                onChange={onChange}
                                value={value}
                                error={error}
                                label="Stage name"
                            />
                        )}
                    />
                    {fields.map((el, idx) => (
                        <SlotField
                            key={el.name}
                            el={el}
                            index={index}
                            innerIndex={innerIndex}
                            idx={idx}
                            control={control}
                            removeSlot={removeSlot}
                            residents={residents}
                        />
                    ))}
                    <CustomButton onClick={addSlot}>Add Time Slot</CustomButton>
                </Field>
            </Collapse>
        </div>
    )
}

export default StageSection
